function formatBytes(bytes: number, decimals = 1) {
  if (bytes === 0) return '0 Bytes';

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function getFileTypeFromFileName(fileName: string) {
  const fileTypes = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'txt',
    'html'
  ];
  const splitFileName = fileName.split('.');
  const fileType = splitFileName[splitFileName.length - 1];

  if (fileTypes.includes(fileType)) {
    return fileType;
  }
}

const FILE_TYPES_BY_CONTENT_TYPE: Record<string, string> = {
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'text/plain': 'txt',
  'text/html': 'html'
};

function getFileTypeFromContentType(contentType: string | null | undefined) {
  return contentType
    ? FILE_TYPES_BY_CONTENT_TYPE[contentType.split(';')[0].trim()]
    : undefined;
}

function downloadFileFromBlobUrl(url: string, filename: string) {
  if (!url.startsWith('blob:')) {
    throw new Error('Invalid URL type - must be a Blob URL');
  }

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false
  });

  const link = document.createElement('a');
  link.download = filename;
  link.href = url;
  link.dispatchEvent(clickEvent);
}

function downloadFileFromUrl(url: string, fileName: string) {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      downloadFileFromBlobUrl(blobUrl, fileName);
      URL.revokeObjectURL(blobUrl); // Clean up
    })
    .catch((e) => console.error('Error in downloading file : ', e));
}

const getFileNameWithExtension = (fileName: string, contentType: string) => {
  // Extract the extension from the file name, if present
  const extension = fileName.includes('.')
    ? fileName.split('.').pop()
    : contentType.split('/')[1];

  const fileNameWithExtension = `${fileName.split('.')[0]}.${extension}`;

  return fileNameWithExtension;
};

export {
  formatBytes,
  getFileTypeFromFileName,
  getFileTypeFromContentType,
  downloadFileFromBlobUrl,
  downloadFileFromUrl,
  getFileNameWithExtension
};
